import { render, staticRenderFns } from "./viscreen.vue?vue&type=template&id=49218b1a&scoped=true"
import script from "./viscreen.vue?vue&type=script&lang=js"
export * from "./viscreen.vue?vue&type=script&lang=js"
import style0 from "./viscreen.vue?vue&type=style&index=0&id=49218b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49218b1a",
  null
  
)

export default component.exports